const _moduleExport = {
    MAX_DOUBLE_LENGTH: 15
};
export { _moduleExport as DATA_TYPES };
